export default "__VITE_ASSET__CWF1B7NL__"